import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { PoweredByTalogent } from '@platform/ui-kit';
import { WS_COLOR } from '@platform/ui-kit/workspace';

/**
 * The vendor attribution row under every screen in the workspace shell: "Powered by Talogent"
 * centred and the installed version at the right, as the Classic footer bar shows them. It is a
 * row of its own, not an overlay, so no screen can run underneath it.
 */
export function AttributionRow({ versionLabel }: { versionLabel: string | undefined }) {
  return (
    <>
      <PoweredByTalogent />
      {versionLabel ? (
        <Box sx={{ position: 'absolute', right: 16, display: { xs: 'none', sm: 'block' } }}>
          <Typography
            title={versionLabel}
            sx={{
              fontSize: 12,
              color: WS_COLOR.textMuted,
              userSelect: 'text',
              whiteSpace: 'nowrap',
            }}
          >
            Version {versionLabel}
          </Typography>
        </Box>
      ) : null}
    </>
  );
}
